import group from "./undo_group";
import {getSheet} from "../sheets";
import {eachRange} from "../helpers/column_names";
import {find, findIndex} from "../helpers/array";

export function init(view){
	view.comments = {
		get: function(row, column, page){
			return getComment(view, row, column, page);
		},
		add: function(row, column, comment, page){
			commentCell(view, row, column, comment, false, page);
		},
		remove: function(row, column, page){
			removeComment(view, row, column, false, page);
		},
		_activeComment: {},
		_pull:{}
	};

	view.attachEvent("onReset", () => reset(view));
	view.attachEvent("onUndo", (type, row, column, value) => {
		if (type === "comment")
			_undoComment(view, row, column, value);
	});

	view.attachEvent("onAction", (action, p)=> {
		if(action == "before-grid-change")
			updatePosition(view, p.name,p.inc,p.data, p.start);
	});
}

function _undoComment(view, row, column, value){
	if(getComment(view, row, column))
		removeComment(view, row, column, true);
	if(value)
		commentCell(view, row, column, value, true);
}

function reset(view){
	view.comments._pull = {};
}

function removeComment(view, row, column, silent, page){
	page = page || view.getActiveSheet();

	const old = getComment(view, row, column, page);
	if(old){
		if(page != view.getActiveSheet()){
			const comments = getSheet(view, page).content.comments;
			const index = findIndex(comments, comment => comment[0] == row && comment[1] == column);
			comments.splice(index, 1);
		}
		else{
			delete view.comments._pull[row][column];
			view.$$("cells").updateItem(row, column);
		}
		if (!silent)
			view.callEvent("onAction", ["comment", {row, column, newValue: null, value: old, page}]);
		
	}
}

export function removeCommentsRange(view, range, page){
	group.set(function(){
		range.split(";").forEach(ref => {
			eachRange(ref, view, function(view, cell){
				if(getComment(view, cell.row, cell.column, page))
					removeComment(view, cell.row, cell.column, false, page);
			});
		});
	});
}

function commentCell(view, row, column, comment, silent, page){
	page = page || view.getActiveSheet();
	const oldValue = getComment(view, row, column, page) || null;

	if(page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(!sheet.content.comments)
			sheet.content.comments = [];

		if(oldValue)
			find(sheet.content.comments, comment => comment[0] == row && comment[1] == column)[2] = comment;
		else
			sheet.content.comments.push([row, column, comment]);
	}
	else{
		

		if(typeof comment == "string")
			comment = comment.trim() ? comment : "";
		view.comments._pull[row] = view.comments._pull[row] ? view.comments._pull[row] : {};
		view.comments._pull[row][column] = comment;

		view.$$("cells").addCellCss(row, column, "ssheet_commented_cell");
	}

	if (!silent)
		view.callEvent("onAction", ["comment", {row, column, newValue:comment, value:oldValue, page}]);
}

export function serialize(view,data){
	var row, column,
		comments = [];
	for(row in view.comments._pull){
		for(column in view.comments._pull[row])
			if(view.comments._pull[row][column])
				comments.push([row, column, view.comments._pull[row][column]]);
	}
	data.comments = comments;
}

export function load(view,data){
	var i,
		comments = data.comments;

	if(comments)
		for(i = 0; i < comments.length; i++)
			commentCell(view, comments[i][0], comments[i][1], comments[i][2], true);
}

function updatePosition(view, name, inc, data, start){
	let comments = data.comments,
		i = comments.length;

	if(inc){
		while(i--){
			let [row,column] = comments[i];
			if(row && name == "row" && row>= start.row || column && name == "column" && column >= start.column){
				if (name == "row"){
					if (row < start.row - inc)	//delete comment if row was deleted
						comments.splice(i,1);
					else						//update mark position if upper row was deleted
						comments[i][0] = row*1 + inc;
				} else if (name == "column"){
					if (column < start.column - inc){
						comments.splice(i, 1);
					} else 
						comments[i][1] = column*1 + inc;
				}
			}
		}
	}
}

function getComment(view, row, column, page){
	let comment;
	if(page && page != view.getActiveSheet()){
		const sheet = getSheet(view, page);
		if(sheet && sheet.content.comments){
			comment = find(sheet.content.comments, comment => comment[0] == row && comment[1] == column);
			if(comment)
				comment = comment[2];
		}
	}
	else if(view.comments._pull[row] && view.comments._pull[row][column])
		comment = view.comments._pull[row][column];
	return comment || "";
}